import { z } from 'zod';
import { paginationSchema } from './common.js';

/**
 * Inventur: Standort wählen, Geräte durchscannen, Abweichungen sehen.
 * In Snipe-IT vorhanden, aber nie genutzt — mit Handy-Scan erstmals praktikabel.
 */

export const inventoryItemStateSchema = z.enum([
  'confirmed', // erwartet und vorgefunden
  'missing', // erwartet, nicht vorgefunden
  'unexpected', // vorgefunden, aber woanders gebucht
]);

export const inventorySessionSchema = z.object({
  id: z.number().int(),
  location: z.object({ id: z.number().int(), name: z.string() }),
  started_by: z.string().nullable(),
  started_at: z.string(),
  closed_at: z.string().nullable(),
  note: z.string().nullable(),
  expected_count: z.number().int(),
  confirmed_count: z.number().int(),
  missing_count: z.number().int(),
  unexpected_count: z.number().int(),
});

export const inventoryStartSchema = z.object({
  location_id: z.number().int().positive(),
  note: z.string().trim().max(1000).optional(),
});

export const inventoryScanSchema = z.object({
  /** Roher Scan — URL, ID, Tag oder Seriennummer. */
  code: z.string().trim().min(1).max(500),
});

export const inventoryCloseSchema = z.object({
  /** Vorgefundene Fremdgeräte direkt auf diesen Standort umbuchen. */
  move_unexpected: z.boolean().default(false),
  note: z.string().trim().max(1000).optional(),
});

export const inventoryListQuerySchema = paginationSchema.extend({
  location_id: z.coerce.number().int().positive().optional(),
  open_only: z.coerce.boolean().optional(),
});
